<template>
  <div class="home">
    <h2>Localisations</h2>
    <b-button
      @click="raisePopup({ target: $event.target, isActive: true })"
      variant="primary"
    >
      Add new
    </b-button>
    <b-modal
      id="localisationsModal"
      v-bind:title="this.isEdit ? 'Edit localisation' : 'New localisation'"
      @ok="localisationFormSubmit"
      :ok-disabled="!form.whitelabelId || !form.translations"
    >
      <span class="edit-warning" v-if="this.isEdit"
        >This action will overwrite translations for
        {{ form.whitelabelName }}</span
      >
      <b-form>
        <b-form-group
          id="newLocalisationInputGroup1"
          label="Whitelabel ID:"
          label-for="newLocalisationInput1"
        >
          <b-form-input
            id="newLocalisationInput1"
            type="number"
            v-model="form.whitelabelId"
            placeholder="Enter Whitelabel ID"
            v-bind:disabled="this.isEdit"
          /> </b-form-group
        ><b-form-group
          id="newLocalisationInputGroup2"
          label="Translations:"
          label-for="newLocalisationFile1"
          ><b-form-file
            id="newLocalisationFile1"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            v-model="form.translations"
          ></b-form-file
        ></b-form-group>
        <b-form-checkbox v-model="form.isActive" name="check-button" switch>
          IsActive
        </b-form-checkbox>
      </b-form></b-modal
    >
    <b-container fluid>
      <b-table
        show-empty
        small
        striped
        :items="this.$store.state.localisations.rows"
        :fields="fields"
        stacked="md"
        class="localisation-table"
        ><template v-slot:cell(whitelabelId)="row">
          {{ row.item.whitelabelId }} ({{ row.item.whitelabel.name }})
        </template>
        <template v-slot:cell(translations)="row">
          <div>
            <vue-json-pretty
              :deep="0"
              :data="row.item.translations"
            ></vue-json-pretty>
          </div>
        </template>
        <template v-slot:cell(actions)="row">
          <b-button
            size="sm"
            variant="success"
            class="m-1 ml-3"
            @click="download(row.item.translations, row.item.whitelabel.name)"
            >⇩</b-button
          >
          <b-button
            size="sm"
            class="m-1 ml-3"
            variant="warning"
            @click="
              raisePopup({
                isEdit: true,
                whitelabelId: row.item.whitelabelId,
                whitelabelName: row.item.whitelabel.name,
                isActive: row.item.isActive,
                target: $event.target
              })
            "
          >
            ✎
          </b-button>
          <b-button
            size="sm"
            variant="danger"
            class="m-1 ml-3"
            @click="deleteLocalisation(row.item.id)"
          >
            X
          </b-button>
          <b-form-checkbox
            v-model="row.item.isActive"
            name="check-button"
            switch
            class="active-switch"
            size="lg"
            @change="changeIsActive(row.item.id)"
          >
          </b-form-checkbox
        ></template>
      </b-table>
      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
/* eslint-disable no-magic-numbers */
import VueJsonPretty from 'vue-json-pretty';

export default {
  name: 'Localisations',
  data() {
    return {
      currentPage: 1,
      perPage: 20,
      pageOptions: [20, 50, 100, 500],
      sortBy: null,
      sortDesc: false,
      filter: null,
      isEdit: false,
      form: {
        whitelabelId: null,
        translations: null,
        whitelabelName: null,
        isActive: false
      }
    };
  },
  computed: {
    fields() {
      return [
        {
          key: 'whitelabelId',
          label: 'whitelabel',
          sortable: true
        },
        { key: 'translations', label: 'translations' },
        { key: 'actions', label: 'actions' }
      ];
    },
    totalRows() {
      return this.$store.state.localisations.rows?.count;
    }
  },

  methods: {
    raisePopup({ whitelabelId, whitelabelName, isActive, isEdit, target }) {
      this.$root.$emit('bv::show::modal', 'localisationsModal', target);
      this.isEdit = isEdit;
      this.form.whitelabelId = isEdit ? whitelabelId : null;
      this.form.translations = null;
      this.form.whitelabelName = isEdit ? whitelabelName : null;
      this.form.isActive = isActive;
    },
    download(translations, whitelabelName) {
      const link = document.createElement('a');
      const blob = new Blob([JSON.stringify(translations)], {
        type: 'application/json'
      });

      link.href = window.URL.createObjectURL(blob);
      link.download = `${whitelabelName}_translations.json`;
      link.click();
    },
    deleteLocalisation(id) {
      if (confirm('Delete this item?')) {
        const promise = this.$store.dispatch('removeLocalisation', {
          id
        });
        promise.then(this.getLocalisations);
      }
    },
    changeIsActive(id) {
      const promise = this.$store.dispatch('changeIsActive', {
        id
      });
      promise.then(this.getLocalisations).catch(this.getLocalisations);
    },
    localisationFormSubmit() {
      const formData = new FormData();
      formData.append('translations', this.form.translations);
      formData.append('whitelabelId', this.form.whitelabelId);
      formData.append('isActive', this.form.isActive);
      const promise = this.$store.dispatch(
        this.isEdit ? 'editLocalisation' : 'addLocalisation',
        formData
      );
      promise.then(this.getLocalisations);
    },
    getLocalisations() {
      const promise = this.$store.dispatch('getLocalisations');

      return promise.then(() => {
        return this.$store.state.localisations.rows || [];
      });
    }
  },
  created: function() {
    this.getLocalisations();
  },
  components: { VueJsonPretty }
};
</script>

<style scoped>
.localisation-table {
  margin-top: 2rem;
}

.edit-warning {
  display: inline-block;
  margin-bottom: 1rem;
  color: red;
}

.active-switch {
  display: inline-block;
  margin-left: 1rem;
}
</style>
